import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import PermissionGuard from '../../components/PermissionGuard'
import AnalyticsStitchScreen from './components/AnalyticsStitchScreen'
import { getAnalyticsScreen } from './constants/stitchAnalyticsScreens'
import JobAnalyticsScreen from './job/JobAnalyticsScreen'
import ProjectAnalyticsScreen from './project/ProjectAnalyticsScreen'
import TaskAnalyticsScreen from './task/TaskAnalyticsScreen'
import UserAnalyticsScreen from './user/UserAnalyticsScreen'

export default function AnalyticsScreen() {
  const { module = 'user' } = useParams()
  const screen = useMemo(() => getAnalyticsScreen(module), [module])

  if (module === 'user') {
    return (
      <PermissionGuard privilege="AnalyticsUserView" module="analytics" routeLabel="User Analytics">
        <UserAnalyticsScreen />
      </PermissionGuard>
    )
  }
  if (module === 'project') {
    return (
      <PermissionGuard privilege="AnalyticsProjectView" module="analytics" routeLabel="Project Analytics">
        <ProjectAnalyticsScreen />
      </PermissionGuard>
    )
  }
  if (module === 'task') {
    return (
      <PermissionGuard privilege="AnalyticsTaskView" module="analytics" routeLabel="Task Analytics">
        <TaskAnalyticsScreen />
      </PermissionGuard>
    )
  }
  if (module === 'job') {
    return (
      <PermissionGuard privilege="AnalyticsJobView" module="analytics" routeLabel="Job Analytics">
        <JobAnalyticsScreen />
      </PermissionGuard>
    )
  }

  return <AnalyticsStitchScreen html={screen.html} title={screen.title} />
}
